<template>

  <div v-if="showNewUi" class="mb-3">
    <div class="p-3 border border-2 border-dark d-flex flex-row" style="border-radius: 1rem">
      <div style="margin-top: -0.9rem">
        <b-form-checkbox
            id="checkbox-cash"
            :checked="selectedPaymentMethod"
            @change="selectPayByCash"
            name="checkbox-cash"
            value="3"
        />
      </div>

      <div class="d-flex">
        <img style="width: 2.5rem" alt="credit card icon" src="../../../../assets/images/button-icons/gift-card.svg"/>
        <span class="ml-3" style="padding-top: 0.1rem">Pay by cash</span>
      </div>
    </div>

  </div>

  <div v-else>
    <div class="form-row">
      <div class="col-sm-12">
        <button
            :disabled="payButtonsAreDisabled"
            type="button"
            @click.prevent="pay"
            class="btn btn-primary btn-lg btn-block mb-2 d-flex justify-content-center align-items-center"
            :style="orderButtonStyles"
        >
          {{ $t("message.payByCash") }} ({{
            getTotalPrice | formatMoney(currencySign)
          }})
          <span v-show="proccessing && selectedPaymentMethod === 3">
                              <i class="spin-sm ml-4" />
                            </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  props: {
    selectedPaymentMethod: {
      type: Number,
      default: null,
    },
    getTotalPrice : {
      type : Number
    },
    proccessing : {
      type : Boolean,
      default: false
    },
    payButtonsAreDisabled : {
      type : Boolean,
      default: false
    }
  },

  computed : {
    ...mapGetters([
      "mobileStyles",
      "showNewUi",
    ]),
    orderButtonStyles() {
      const styles = [];
      styles.push({
        ...this.mobileStyles.btn,
        ...this.mobileStyles.mobilePlaceOrderButton,
      });
      if (this.showNewUi) {
        styles.push({
          height: "48px",
        });
      }

      return styles;
    },
  },

  methods: {
    pay(){
      this.$emit('setMethodAndPlaceOrder', 3)
    },
    selectPayByCash(checked) {
      this.$emit('setPaymentMethod', Number(checked) || null)
    }
  }

};
</script>

<style>
.disabled {
  pointer-events: none;
  opacity: 0.4;
}
.enabled {
  opacity: 1;
}
</style>
